import styled from '@emotion/styled';
import Media from '@ep/components/Media';
import { H3, Subhead2 } from '@ep/components/Typography';
import PostCard from '@ep/modules/PostCarouselModule/Post/PostCard';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface PostProps {
  post: Gcms_Post[];
}

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  scroll-snap-align: start;
  flex-shrink: 0;
  > div {
    &:hover {
      transition: 0.25s;
      box-shadow: 4px 4px 10px ${theme.colors.darkGray};
      transform: translate(-4px, -4px);
    }
  }

  ${theme.mediaQueries.mobileAndTablet} {
    grid-template-columns: 1fr;
  }
`;

const StyledPostCard = styled(PostCard)``;

function Post({ post }: PostProps) {
  return (
    <Content>
      {post.map(post => (
        <StyledPostCard key={`Post_carousel__${post.id}`} post={post} />
      ))}
    </Content>
  );
}

export default Post;
